import React, {useContext, useEffect} from 'react';
import {Navigate, Link} from 'react-router-dom'
import {useForm, FormProvider} from "react-hook-form";

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import { TaskStatus } from '../../constants/Consts';
import {Loading} from '../../custom/LoadingComponent'
import {TaskCouponStampOrchestrator} from './TaskCouponStampRenewalOrchestratorComponent';
import BucketContext from "../../context/BucketContext";
import * as WFSteps from '../../constants/WorkflowSteps';
import * as ReduxDataStatus from '../../../utils/constants/ReduxDataStatus';


function TaskDeserventiCouponStampManagement(props) {
    console.log('___TaskDeserventiCouponStampManagement___');

    const bucketContext = useContext(BucketContext);

    useEffect(() => {
        props.loadComponentData();

        if(bucketContext.bucket.mostRecentTaskId != null) {
            console.log('Reseting the mostRecentTaskId: ' + JSON.stringify(bucketContext.bucket.mostRecentTaskId));
            bucketContext.setBucketValue({mostRecentTaskId: null});
        }
    }, []);

    const methods = useForm({
        defaultValues: {
            lTask: props.rsvtiTask
        }
    });

    const [activeStep, setActiveStep] = React.useState(!!props.rsvtiTask?.details?.activeStep? props.rsvtiTask.details.activeStep : 0);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    

    if(props.dataStatus === ReduxDataStatus.IDLE || 
        props.dataStatus === ReduxDataStatus.LOADING) {
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else if(props.rsvtiTask != null){ 
        if (props.rsvtiTask.details.status === TaskStatus.Cancelled) {
            return <Navigate to="/rsvti/deserventi/tasks" replace />;
        }
        else {
            return (
                <Container maxWidth="xl" >
                    <Box px={{ xs: 3, sm: 7 }}>

                        <Stack spacing={1} sx={{ marginBottom: 2 }}>
                            <Box>
                                <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                                    <Link to="/rsvti/deserventi/tasks">Tasks</Link>
                                    <Typography color="text.primary">Programare reinnoire viza talon</Typography>
                                </Breadcrumbs>
                            </Box>

                            <Box>
                                <Box style={{ display: "flex", marginBottom: 4 }}>
                                    <Box sx={{ width: '50%' }} display="flex" justifyContent="flex-start" alignItems="flex-start">
                                        <h3>Programare reinnoire viza talon #{props.rsvtiTask.id}</h3>
                                    </Box>
                                </Box>
                            </Box>
                            <hr />

                            <FormProvider {...methods} >
                                <Box>
                                    <Stepper activeStep={activeStep} sx={{ marginTop: 2, marginBottom: 3 }}>
                                        {WFSteps.couponStampRenealSteps.map((label, index) => {
                                            const stepProps = {};
                                            const labelProps = {};
                                            return (
                                                <Step key={label} {...stepProps}>
                                                    <StepLabel {...labelProps}>{label}</StepLabel>
                                                </Step>
                                            );
                                        })}
                                    </Stepper>

                                    <TaskCouponStampOrchestrator
                                        activeStep={activeStep}
                                        handleNext={handleNext}
                                        handleBack={handleBack}
                                        employers={props.employers}
                                        patchRsvtiTask={props.patchRsvtiTask}
                                        patchAuthzsStampDate={props.patchAuthzsStampDate}
                                    />
                                </Box>
                            </FormProvider>

                        </Stack>

                    </Box>
                </Container>
            );
        }
    }
    else{
        return(
            <div></div>
        );
    };
}

export default TaskDeserventiCouponStampManagement;